import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEarRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 23,
	viewBox: "0 0 20 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.8171 23H0.674194C0.674194 23 3.20316 15.7936 8.95652 8.5C14.7099 1.20637 18.8171 0 18.8171 0C18.8171 0 20 4 20 12.5C20 16.9053 18.8171 23 18.8171 23Z",
		fill: "white"
	})
});
export default SvgEarRight;
